// extracted by mini-css-extract-plugin
export default {"title":"ContactsPage_title__xO9EL","section":"ContactsPage_section__JzV0W","contacts":"ContactsPage_contacts__zABB9"};